<template>
  <div>
    <date-range-picker
      v-model="dateRange"
      time-picker
      :always-show-calendars="true"
      :max-date="minEndDateCom"
      @update="update"
      :show-week-numbers="false"
      auto-apply
      :ranges="false"
      control-container-class="control-container"
    ></date-range-picker>
  </div>
</template>

<script>
import moment from "moment";
import IconDate from "./Iconsvg/IconDate.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  components: { IconDate, DateRangePicker },
  name: "DateComponent",
  data() {
    return {
      startdate: "",
      enddate: "",
      endIsBeforeStart: false,
      "max-date": "",
      "min-date": "",
      dateRange: {
        startDate: this.minStartDate,
        endDate: this.maxEndDate,
      },
    };
  },
  computed: {
    isValidStartDate() {
      return this.isValidDate(this.startdate);
    },
    isValidEndDate() {
      return this.isValidDate(this.enddate);
    },
    isStartDateBeforeEndDate() {
      return moment(this.startdate).isBefore(this.enddate);
    },
    period() {
      return (
        this.isValidStartDate &&
        this.isValidEndDate &&
        this.isStartDateBeforeEndDate
      );
    },
    maxEndDate() {
      return moment().format("YYYY-MM-DD");
    },
    minEndDateCom() {
      const maxEndDateWithTime = new Date(this.maxEndDate);
      return maxEndDateWithTime.setHours(23, 59, 59, 999);
    },
    minStartDate() {
      return moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD");
    },
    ranges() {
      return [this.dateRange?.startDate, this.maxEndDate];
    },
  },
  created() {
    const minStartDateWithTime = new Date(this.minStartDate);
    minStartDateWithTime.setHours(0, 0, 0, 0);

    const maxEndDateWithTime = new Date(this.maxEndDate);
    maxEndDateWithTime.setHours(23, 59, 59, 999);

    this.dateRange = {
      startDate: minStartDateWithTime,
      endDate: maxEndDateWithTime,
    };
    this.update({
      startDate: minStartDateWithTime,
      endDate: maxEndDateWithTime,
    });
  },
  methods: {
    isValidDate(dateString) {
      return moment(dateString, "YYYY-MM-DD", true).isValid();
    },
    handleDateChange() {
      this.endIsBeforeStart = !this.isStartDateBeforeEndDate;
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
    update({ endDate, startDate }) {
      let period = {
        startdate: moment(startDate).format(),
        enddate: moment(endDate).format(),
      };

      this.$emit("period", period);
    },
  },
  watch: {
    period() {
      let period = {
        startdate: this.period ? moment(this.startdate).format() : "",
        enddate: this.period ? moment(this.enddate).format() : "",
      };

      this.$emit("period", period);
    },
    startdate: "handleDateChange",
    enddate: "handleDateChange",
  },
};
</script>

<style scoped>
.date-component {
  border-radius: 16px;
  border: 0.5px solid #b7c3cd;
  padding: 13px 0px 13px 13px;
  width: fit-content;
  background: white;
}
.dash {
  position: relative;
  /* left: -12px; */
  margin-right: 8px;
}

input {
  background: white !important;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
}

input[type="date"]::-moz-calendar-picker-indicator {
  display: none;
}

input[type="date"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

/* .v-date-picker {
  display: flex;
  align-items: center;
  column-gap: 5px;
} */

.control-container .vue-daterange-picker .reportrange-text {
  border-radius: 16px;
  border: 0.5px solid #b7c3cd;
  padding: 13px !important;
  width: fit-content;
  background: white;
}

.control-container {
  display: flex;
  align-items: center;
  column-gap: 5px;
  cursor: pointer !important;
}
</style>
